// Mappatura provincia italiana → macro-area geografica commerciale.
// Mirror del backend `services/geo_zones.py`.

const PROVINCE_TO_REGION = {
  // Piemonte
  TO: 'Piemonte', AL: 'Piemonte', AT: 'Piemonte', BI: 'Piemonte',
  CN: 'Piemonte', NO: 'Piemonte', VB: 'Piemonte', VC: 'Piemonte',
  // Valle d'Aosta
  AO: "Valle d'Aosta",
  // Lombardia
  MI: 'Lombardia', BG: 'Lombardia', BS: 'Lombardia', CO: 'Lombardia',
  CR: 'Lombardia', LC: 'Lombardia', LO: 'Lombardia', MN: 'Lombardia',
  MB: 'Lombardia', PV: 'Lombardia', SO: 'Lombardia', VA: 'Lombardia',
  // Trentino-Alto Adige
  TN: 'Trentino-Alto Adige', BZ: 'Trentino-Alto Adige',
  // Veneto
  VE: 'Veneto', BL: 'Veneto', PD: 'Veneto', RO: 'Veneto',
  TV: 'Veneto', VI: 'Veneto', VR: 'Veneto',
  // Friuli
  UD: 'Friuli-Venezia Giulia', GO: 'Friuli-Venezia Giulia',
  PN: 'Friuli-Venezia Giulia', TS: 'Friuli-Venezia Giulia',
  // Liguria
  GE: 'Liguria', IM: 'Liguria', SP: 'Liguria', SV: 'Liguria',
  // Emilia-Romagna
  BO: 'Emilia-Romagna', FC: 'Emilia-Romagna', FE: 'Emilia-Romagna',
  MO: 'Emilia-Romagna', PC: 'Emilia-Romagna', PR: 'Emilia-Romagna',
  RA: 'Emilia-Romagna', RE: 'Emilia-Romagna', RN: 'Emilia-Romagna',
  // Toscana
  FI: 'Toscana', AR: 'Toscana', GR: 'Toscana', LI: 'Toscana',
  LU: 'Toscana', MS: 'Toscana', PI: 'Toscana', PT: 'Toscana',
  PO: 'Toscana', SI: 'Toscana',
  // Marche
  AN: 'Marche', AP: 'Marche', FM: 'Marche', MC: 'Marche', PU: 'Marche',
  // Umbria
  PG: 'Umbria', TR: 'Umbria',
  // Lazio
  RM: 'Lazio', FR: 'Lazio', LT: 'Lazio', RI: 'Lazio', VT: 'Lazio',
  // Abruzzo
  AQ: 'Abruzzo', CH: 'Abruzzo', PE: 'Abruzzo', TE: 'Abruzzo',
  // Sardegna
  CA: 'Sardegna', NU: 'Sardegna', OR: 'Sardegna', SS: 'Sardegna', SU: 'Sardegna',
  // Molise
  CB: 'Molise', IS: 'Molise',
  // Campania
  NA: 'Campania', AV: 'Campania', BN: 'Campania', CE: 'Campania', SA: 'Campania',
  // Puglia
  BA: 'Puglia', BT: 'Puglia', BR: 'Puglia', FG: 'Puglia', LE: 'Puglia', TA: 'Puglia',
  // Basilicata
  PZ: 'Basilicata', MT: 'Basilicata',
  // Calabria
  CS: 'Calabria', CZ: 'Calabria', KR: 'Calabria', RC: 'Calabria', VV: 'Calabria',
  // Sicilia
  PA: 'Sicilia', AG: 'Sicilia', CL: 'Sicilia', CT: 'Sicilia', EN: 'Sicilia',
  ME: 'Sicilia', RG: 'Sicilia', SR: 'Sicilia', TP: 'Sicilia',
};

const REGION_TO_ZONE = {};
const ZONE_BY_REGION = {
  sud: ['puglia', 'campania', 'molise', 'basilicata', 'calabria', 'sicilia'],
  centro: ['toscana', 'marche', 'umbria', 'lazio', 'abruzzo', 'sardegna'],
  nord: [
    "valle d'aosta", 'piemonte', 'liguria', 'emilia-romagna',
    'veneto', 'friuli-venezia giulia', 'trentino-alto adige', 'lombardia',
  ],
};
Object.entries(ZONE_BY_REGION).forEach(([zone, regs]) => {
  regs.forEach(r => { REGION_TO_ZONE[r] = zone; });
});

export function getZoneForProvince(province) {
  if (!province) return null;
  const code = String(province).trim().toUpperCase();
  const region = PROVINCE_TO_REGION[code];
  if (!region) return null;
  return REGION_TO_ZONE[region.toLowerCase()] || null;
}

export const ZONE_LABELS = {
  nord: 'Nord Italia',
  centro: 'Centro Italia',
  sud: 'Sud Italia e Isole',
};

export const ZONE_REGIONS = {
  nord: "Valle d'Aosta, Piemonte, Liguria, Emilia Romagna, Veneto, Friuli V.G., Trentino A.A., Lombardia",
  centro: 'Toscana, Marche, Umbria, Lazio, Abruzzo, Sardegna',
  sud: 'Puglia, Campania, Molise, Basilicata, Calabria, Sicilia',
};
